import { render } from "./NhiPanel.vue?vue&type=template&id=3d942bf4"
import script from "./NhiPanel.vue?vue&type=script&lang=js"
export * from "./NhiPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__